import React from "react";
import NoDataWarningTabContent from "./NoDataWarningTabContent";

const ParagraphZoomTabContents: React.FC = ({ children }) => {
  return children ? <div>{children}</div> : <NoDataWarningTabContent />;
};

export default ParagraphZoomTabContents;
